import { render } from "./DiveButton.vue?vue&type=template&id=0316e8bf&scoped=true"
import script from "./DiveButton.vue?vue&type=script&lang=js"
export * from "./DiveButton.vue?vue&type=script&lang=js"

import "./DiveButton.vue?vue&type=style&index=0&id=0316e8bf&scoped=true&lang=scss"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0316e8bf"]])

export default __exports__